import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
const ButtonLoader = (props) => {
    const { btnHtml, className } = props;
    return (
        <>
            <FontAwesomeIcon icon={faSpinner} spin className={className}/>
            {btnHtml}
        </>
    )
}
export default ButtonLoader